import { Column } from '@/components';
import React, { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faUser, faInfoCircle, faExternalLinkAlt, faAsterisk } from '@fortawesome/free-solid-svg-icons';
import { AddiotionalQuestion } from '../AdditionalQuestion';

export const OptionsTab: FunctionComponent = () => {
  return (
    <div className="flex flex-col gap-6 pt-4 px-2 sm:px-0">
      {/* Banner CTA */}
      <div className="w-full mx-auto sm:max-w-[672px]">
        <div className="border rounded-xl p-4 sm:p-6">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              <FontAwesomeIcon icon={faInfoCircle} className="text-lg" />
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-base mb-2">Configura las políticas de tu negocio</h3>
              <p className="text-sm mb-3 leading-relaxed">
                Personaliza las condiciones de cancelación, términos de servicio y otras políticas
                importantes.
              </p>
              <a
                href="/servicios/edicion-global/politicas"
                target="_blank"
                className="inline-flex items-center gap-2 font-medium text-sm transition-colors group"
              >
                <span>Configurar políticas</span>
                <FontAwesomeIcon
                  icon={faExternalLinkAlt}
                  className="text-xs group-hover:translate-x-0.5 transition-transform"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Form Content */}
      <div className="w-full mx-auto sm:max-w-[672px] sm:border-2 sm:border-gray-200 sm:rounded-xl sm:p-6 sm:bg-white sm:shadow-sm">
        <Column className="w-full">
          <div className="mb-6">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Formulario de compra</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Los clientes completan este formulario al reservar en tu página. Los campos básicos son
              obligatorios, pero puedes agregar preguntas personalizadas para recopilar información adicional
              específica de tu negocio.
            </p>
          </div>

          {/* Required Fields Section */}
          <div className="bg-gray-50 rounded-lg p-4 sm:p-6 mb-6">
            <div className="flex items-center gap-2 mb-4">
              <FontAwesomeIcon icon={faAsterisk} className="text-red-500 text-xs" />
              <h3 className="font-semibold text-gray-900">Campos obligatorios</h3>
            </div>
            <p className="text-sm text-gray-600 mb-4">
              Estos campos siempre aparecerán en el formulario y son requeridos para completar la reserva.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {[
                { icon: faUser, text: 'Nombre', description: 'Nombre del cliente' },
                { icon: faUser, text: 'Apellido', description: 'Apellido del cliente' },
                { icon: faAt, text: 'Email', description: 'Correo electrónico' }
              ].map((field, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg p-4 border border-gray-200 hover:border-gray-300 transition-colors"
                >
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
                      <FontAwesomeIcon icon={field.icon} className="text-gray-600 text-sm" />
                    </div>
                    <div className="flex-1">
                      <h4 className="font-medium text-gray-900 text-sm">{field.text}</h4>
                    </div>
                    <FontAwesomeIcon icon={faAsterisk} className="text-red-500 text-xs" />
                  </div>
                  <p className="text-xs text-gray-500 ml-11">{field.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Additional Questions Section */}
          <div className="bg-white rounded-lg border border-gray-200 p-4 sm:p-6">
            <div className="mb-4">
              <h3 className="font-semibold text-gray-900 mb-2">Preguntas personalizadas</h3>
              <p className="text-sm text-gray-600">
                Agrega hasta 5 preguntas adicionales para recopilar información específica que necesites de
                tus clientes.
              </p>
            </div>
            <AddiotionalQuestion />
          </div>
        </Column>
      </div>
    </div>
  );
};
